<main style="overflow-y: auto !important; overflow-x: hidden">
  <div class="container-fluid row_banner pb-5">
    <app-header></app-header>
    <!-- Edditor  -->
    <div class="container">
      <div class="row text-center justify-content-center">
        <div class="col-lg-9 col-md-9 mb-4">
          <h1 class="title" id="grammarTitle"> {{ "grammarPage.title" | translate }}</h1>
          <p class="description mx-auto" style="margin-top: 0px; max-width: 640px; padding: 0 !important">{{
            "grammarPage.main_text" | translate }}
          </p>
        </div>
      </div>
    </div>

    <section style="min-height: 530px;">
      <ng-template #landerContainer></ng-template>
    </section>

    <!-- <section class="container">
      <div class="editor-card">
        <p
          class="text-left success-msg"
          *ngIf="got_recpatcha"
          [ngStyle]="{
            color: color,
            'background-color': '#f8d7da',
            padding: '2px'
          }"
        >
          <i class="fa fa-times-circle matr ml-1" aria-hidden="true"></i>
          {{ recaptcha_message }}
        </p>

        <div class="row-1">
          <div class="icon-bar">
            <div
              class="icon-bar-img"
              id="uploadFileS"
              value="Browse"
              onclick="document.getElementById('upload').click();"
            >
              <app-icons-free-tools [name]="'pcIcon'" />
              <input
                id="upload"
                data-name="upload-element"
                #fileInput
                accept=".txt,.doc,.docx,.pdf,.odt,.rtf,.tex"
                type="file"
                (change)="uploadFileSaveRedirect($event)"
              />
            </div>
            <div class="icon-bar-img" (click)="openDropboxChooser()">
              <app-icons-free-tools [name]="'dropboxIcon'" />
            </div>
            <div class="icon-bar-img" (click)="gDriveUpload()">
              <app-icons-free-tools [name]="'googleIcon'" />
            </div>
          </div>

          <div class="flex-1">
            <div style="position: relative">
              <quill-editor
                id="editor"
                [(ngModel)]="homeText"
                [modules]="editorModules"
                [theme]="'snow'"
                (onEditorCreated)="onEditorCreated($event)"
                class="typing-editor-quill-editor px-3"
                id="editor"
                #editor
                style="overflow-y: auto; overflow-x: hidden"
                placeholder=""
                (onContentChanged)="count_Words_Character2()"
              >
              </quill-editor>

              <div *ngIf="showParagraph" class="editSectionDiv">
                <div *ngFor="let content of contentArray">
                  <app-icons-free-tools [name]="'checktextIcon'" />
                  <p class="editor-heading">{{ content.header }}</p>
                  <p class="paragraph">{{ content.paragraph }}</p>
                  <div class="upload-buttons">

            <div
              value="Browse"
              onclick="document.getElementById('upload').click();"
                      class="textButtons"
                      style="padding-right: 0.75rem; cursor: pointer; font-weight: 500; gap: 0"
            >
                  <svg width="43" height="43" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M24.9687 15.1719H16.3217C15.2983 15.1719 14.4688 15.9584 14.4688 16.9288V29.2269H34.2335V23.9563" stroke="#08BA9C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M12 29.2266H36.7059V30.3978C36.7059 32.3384 35.0467 33.9116 33 33.9116H15.7059C13.6592 33.9116 12 32.3384 12 30.3978V29.2266Z" stroke="#08BA9C" stroke-width="2" stroke-linejoin="round"></path>
<path d="M32.3828 21.0275V14" stroke="#08BA9C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M29.293 16.9281L32.3812 14L35.4694 16.9281" stroke="#08BA9C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
</svg>
Upload File
              <input
                id="upload"
                data-name="upload-element"
                #fileInput
                accept=".txt,.doc,.docx,.pdf,.odt,.rtf,.tex"
                type="file"
                (change)="uploadFileSaveRedirect($event)"
              />
            </div>
                    <button
                      [ngClass]="{
                        paste: button.text === 'Sample Text',
                        click: button.text === 'Paste Text',
                        'default-class': true
                      }"
                      *ngFor="let button of content.buttons"
                      class="textButtons"
                      (click)="executeAction(button.action)"
                    >
                      <app-icons-free-tools [name]="button.icon" />{{
                        button.text
                      }}
                    </button>
                  </div>
                </div>
              </div>
              <span *ngIf="char_count !== 0">
                <app-icons-free-tools
                  [name]="'deleteIcon'"
                  (click)="deleteText()"
                  class="icon-del"
                />
              </span>
              <div class="progress-loader-div">
                <div class="progress-loader" *ngIf="loaderAlert"></div>
              </div>
              <div class="bottom-icon">
                <div class="word-char">
                  <span class="wordCount">
                    Words: {{ char_count === 0 ? 0 : word_count }}
                  </span>
                  <span class="wordCount"
                    >Total Characters: {{ char_count }}</span
                  >
                </div>

                <div *ngIf="captchaVisible" class="captcha-modal-overlay">
                  <div class="captcha-modal">
                    <div
                      id="recaptcha-container"
                      class="recaptcha-container"
                      data-size="compact"
                      data-theme="light"
                    ></div>
                  </div>
                </div>

                <div class="">
                  <button
                    class="btn-Proofread buton"
            [ngClass]="{
              'check-grammar-btn-loading': loaderAlert
            }"
                    (click)="handleButtonClick()"
                  >
                    {{ loaderAlert ? 'Checking' : 'Check Grammar' }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->
  </div>

  <div class="container">
    <div class="row text-center justify-content-center mt-5">
      <div class="col-lg-9 col-md-9 mb-4 px-md-5">
        <h2 class="title"> {{ "grammarPage.How-to-Use" | translate }}</h2>
        <span class="description">

          {{ "grammarPage.How-to-Use-text" | translate }}
        </span>
      </div>
    </div>

    <div class="row">
      <div *ngFor="let step of steps" class="col-xl-3 col-lg-6 col-md-6 mb-3">
        <div class="grammarTab">
          <app-icons-free-tools [name]="step.icon" />
          <h3 class="mt-3">{{ step.title | translate }}</h3>
          <p class="mt-1">{{ step.description | translate }}</p>
        </div>
      </div>
    </div>
  </div>

  <div class="container">
    <app-premium />
  </div>

  <section class="grammar-section mt-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 col-md-12 col-sm-12 feature-list">
          <div *ngFor="let feature of features" class="row feature-item">
            <div class="col icon-container" [id]="feature.id1 || null">
              <app-icons-free-tools [name]="feature.icon" />
              <span>{{ feature.title | translate }}</span>
            </div>
            <div class="col text-container" [id]="feature.id2 || null">
              <p class="ms-md-3">{{ feature.description | translate }}</p>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-md-12 col-sm-12 description">
          <h2 class="titleL mt-3">
            {{ "grammarPage.Free-Grammar" | translate }} <br />
            {{ "grammarPage.Ultimate-Writing" | translate }}
          </h2>

          <p class="descriptionL mt-5">
            {{ "grammarPage.GrammarIn-free-detail" | translate }}
          </p>
        </div>
      </div>
    </div>
  </section>

  <!-- <section class="intro-section mt-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 col-md-12 col-sm-12 intro-list-text">
          <div class="introduction mt-5">
            <h2 class="titleL">Introduction to Grammar Checker</h2>
            <p class="descriptionL mt-3">
              Grammar Checker is designed to help users detect and correct
              grammar mistakes in their content. GrammarIn aims to promote
              effective communication in this tech-driven environment. Hence, it
              has developed an AI-powered grammar corrector that focuses on
              improving textual content quality. Whether your text contains
              <a href="https://www.grammarin.com/handbook/grammar" class="aTag"
                >grammar
              </a>
              ,
              <a
                href="https://www.grammarin.com/handbook/punctuation"
                class="aTag"
              >
                punctuation </a
              >, spelling, or syntax errors, our grammar checker covers you. It
              makes sure to conduct an in-depth grammar check on your text to
              help you make it accessible for all kinds of errors in seconds.
            </p>
          </div>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12 intro-list-col">
          <div class="intro-list">
            <img
              src="../../assets/images/illustration/grammar-checker.svg"
              alt="Introduction to Grammar Checker"
              width="392px"
              height="339px"
            />
          </div>
        </div>
      </div>
    </div>
  </section> -->

  <section class="moreThan-section mt-5">
    <div class="container" id="moreSection">
      <div class="row text-center justify-content-center mt-5">
        <div class="col-lg-9 col-md-9 mb-4 px-md-5">
          <h2 class="title"> {{ "grammarPage.Why-GrammarIn" | translate }}</h2>
          <span class="description">
            {{ "grammarPage.Why-GrammarIn-description" | translate }}
          </span>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6 col-sm-12 mtsmall" style="padding: 0px">
          <div id="moreSectiontab">
            <img src="../../assets/images/free-grammarchecker/Enhancing Language Diversity.svg"
              alt="Enhancing Language Diversity" width="450px" height="170px" />

            <h3> {{ "grammarPage.LanguageDiversityTitle" | translate }}</h3>
            <p>

              {{ "grammarPage.LanguageDiversityDescription" | translate }}
              <a href="https://www.grammarin.com/blog/how-to-overcome-language-barriers/" target="_blank" class="aTag">
                {{ "grammarPage.language-barriers" | translate }}</a>

              {{ "grammarPage.making-writing-clearer" | translate }}
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-sm-12 mtsmall" style="padding: 0px">
          <div id="moreSectiontab">
            <img src="../../assets/images/free-grammarchecker/NLP Algorithms.svg" alt="NLP Algorithms" width="450px"
              height="170px" />

            <h3> {{ "grammarPage.NLPAlgorithmsTitle" | translate }}</h3>
            <p>

              {{ "grammarPage.NLPAlgorithmsDescription" | translate }}
            </p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6 col-sm-12 mtsmall" style="padding: 0px">
          <div id="moreSectiontab">
            <img src="../../assets/images/free-grammarchecker/AI-Driven Proofreading.svg" alt="AI-Driven Proofreading"
              width="450px" height="170px" />
            <h3> {{ "grammarPage.AIProofreadingTitle" | translate }}</h3>
            <p>

              {{ "grammarPage.AIProofreadingDescription" | translate }}
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-sm-12 mtsmall" style="padding: 0px">
          <div id="moreSectiontab">
            <img src="../../assets/images/free-grammarchecker/Flexible Writing Styles.svg" alt="Flexible Writing Styles"
              width="450px" height="170px" />
            <h3>{{ "grammarPage.FlexibleWritingStylesTitle" | translate }}</h3>
            <p>

              {{ "grammarPage.FlexibleWritingStylesDescription1" | translate }}
              <a href="https://www.grammarin.com/handbook/style" class="aTag">
                {{ "grammarPage.style" | translate }}
              </a>

              {{ "grammarPage.FlexibleWritingStylesDescription2" | translate }}
            </p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6 col-sm-12 mtsmall" style="padding: 0px">
          <div id="moreSectiontab">
            <img src="../../assets/images/free-grammarchecker/enhanced-writing-speed-1.svg" alt="Enhanced Writing Speed"
              width="450px" height="170px" />
            <h3>{{ "grammarPage.Enhanced-Writing-Speed" | translate }}</h3>
            <p>

              {{ "grammarPage.Enhanced-Writing-Speed-detail" | translate }}
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-sm-12 mtsmall" style="padding: 0px">
          <div id="moreSectiontab">
            <img src="../../assets/images/free-grammarchecker/Improved-Document-Formatting.svg"
              alt="Improved Document Formatting" width="450px" height="170px" />
            <h3> {{ "grammarPage.Improved-Document-Formatting" | translate }}</h3>
            <p>

              {{ "grammarPage.Improved-Document-Formatting-detail" | translate }}
            </p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-3 d-md-block d-non" style="padding: 0px"></div>
        <div class="col-lg-6 col-sm-12 mtsmall" style="padding: 0px">
          <div id="moreSectiontab">
            <img src="../../assets/images/free-grammarchecker/Customizable-Writing-Goals.svg"
              alt="Customizable Writing Goals" width="450px" height="170px" />
            <h3> {{ "grammarPage.Customizable-Writing-Goals" | translate }}</h3>
            <p>

              {{ "grammarPage.Customizable-Writing-Goals-detail" | translate }}
            </p>
          </div>
        </div>
        <div class="col-lg-3 d-md-block d-non" style="padding: 0px"></div>
      </div>
    </div>
  </section>

  <section class="common-writing mt-5">
    <div class="container">
      <div class="row text-center justify-content-center">
        <div class="col-lg-9 col-md-9 mb-4 px-md-5">
          <h2 class="title">

            {{ "grammarPage.Detect-Fix-Common-Writing" | translate }}
          </h2>
          <span class="description">
            <a class="aTag"
              [routerLink]="selectedLanguage.code === 'en' ? '/grammar-checker' : '/' + selectedLanguage.code + '/grammar-checker'"
              target="_blank"> {{ "grammarPage.AI-grammar-checker" | translate }}
            </a>
            <!-- href="https://www.grammarin.com/grammar-checker" -->



            {{ "grammarPage.AI-grammar-checker-detail" | translate }}
          </span>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-4 martop">
          <div class="common-tab">
            <app-icons-free-tools [name]="'fixPunctuationErrorsIcon'" />
            <h3> {{ "grammarPage.Fix-Punctuation-Errors" | translate }}</h3>
            <p>
              {{ "grammarPage.missing" | translate }}
              <a href="https://www.grammarin.com/what-is-a-comma" class="aTag">
                {{ "grammarPage.commas" | translate }} </a>,
              <a href="https://www.grammarin.com/what-is-a-semicolon" class="aTag">
                {{ "grammarPage.semicolons" | translate }}
              </a>
              {{ "grammarPage.periods-incorrect" | translate }}
              <a href="https://www.grammarin.com/when-to-use-quotation-marks" class="aTag">
                {{ "grammarPage.quotation-marks" | translate }}
              </a>
              {{ "grammarPage.Fix-Punctuation-Errors-detail1" | translate }}
              <a href="https://www.grammarin.com/punctuation-checker" class="aTag">
                {{ "grammarPage.punctuation-checker" | translate }}
              </a>
              {{ "grammarPage.Fix-Punctuation-Errors-detail2" | translate }}
            </p>
          </div>
        </div>

        <div class="col-lg-4 martop">
          <div class="common-tab">
            <app-icons-free-tools [name]="'checkGrammarMistakeIcon'" />
            <h3> {{ "grammarPage.title-Correct-Grammar" | translate }}</h3>
            <p>
              {{ "grammarPage.detail-Correct-Grammar" | translate }}
            </p>
          </div>
        </div>
        <div class="col-lg-4 martop">
          <div class="common-tab">
            <app-icons-free-tools name="subjectVerbAgreementIcon" />
            <h3> {{ "grammarPage.title-Clarity/Tone-Improvements" | translate }}</h3>
            <p>

              {{ "grammarPage.detail-title-Clarity/Tone-Improvements" | translate }}
            </p>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-lg-6">
          <div class="common-tabM">
            <app-icons-free-tools [name]="'incorrectSingularIcon'" />
            <h3> {{ "grammarPage.title-Incorrect" | translate }}</h3>
            <p>
              {{ "grammarPage.detail-Incorrect" | translate }}
              <a href="https://www.grammarin.com/what-are-nouns" class="aTag"> {{ "grammarPage.nouns" | translate }}
              </a>
              {{ "grammarPage.their-verbs" | translate }}
              <a href="https://www.grammarin.com/what-are-pronouns" class="aTag">
                {{ "grammarPage.pronouns" | translate }}
              </a>
              {{ "grammarPage.title-Incorrect-detail" | translate }}
            </p>
          </div>
        </div>
        <div class="col-lg-6 martop">
          <div class="common-tabM">
            <app-icons-free-tools [name]="'eliminateWrongSpellingIcon'" />
            <h3> {{ "grammarPage.title-Spelling-Corrections" | translate }}</h3>
            <p>
              {{ "grammarPage.detail1-Spelling-Corrections" | translate }}
              <a href="https://www.grammarin.com/what-are-spelling-rules" class="aTag">
                {{ "grammarPage.spelling-rules" | translate }}</a>

              {{ "grammarPage.detail2-Spelling-Corrections" | translate }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="keyFeatures mt-5">
    <div class="container mt-3">
      <div class="row">
        <div class="col-md-5 mt-5">
          <h2 class="titleL"> {{ "grammarPage.Benefits-of-Grammar-Check-title" | translate }}</h2>
        </div>
        <div class="col-md-7 mt-5">
          <p class="descriptionL">

            {{ "grammarPage.Benefits-of-Grammar-Check-detail" | translate }}
          </p>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-lg-6 martop">
          <div class="keyFeatureTab">
            <div>
              <app-icons-free-tools [name]="'contextBasedSuggestionsIcon'" />
            </div>
            <div class="marleft">
              <h3>{{ "grammarPage.title-Context" | translate }}</h3>
              <p>

                {{ "grammarPage.detail-Context" | translate }}
              </p>
            </div>
          </div>
        </div>

        <div class="col-lg-6 martop">
          <div class="keyFeatureTab">
            <div>
              <app-icons-free-tools [name]="'superQuickResultsIcon'" />
            </div>
            <div class="marleft">
              <h3>{{ "grammarPage.title-Super-Quick-Results" | translate }}</h3>
              <p>
                {{ "grammarPage.detail-Super-Quick-Results" | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col">
          <div class="keyFeatureTabE">
            <div>
              <app-icons-free-tools [name]="'universalCompatibilityIcon'" />
            </div>
            <div class="marleft">
              <h3>{{ "grammarPage.title-Universal" | translate }}</h3>
              <p>

                {{ "grammarPage.detail-Universal" | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <br /><br />
    </div>
  </section>

  <section class="potential mt-5">
    <div class="container">
      <div class="row text-center justify-content-center">
        <div class="col-lg-9 col-md-9 mb-4 px-md-5">
          <h2 class="title"> {{ "grammarPage.Potential-Users" | translate }}</h2>
          <span class="description">
            {{ "grammarPage.Potential-Users-detail" | translate }}
          </span>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6">
          <div class="">
            <img [src]="getImageSrc()" alt="Tab Image" class="potential-img-tab" width="562px" height="500px" />
          </div>
        </div>

        <div class="col-lg-6 mtsmall">
          <div class="vertical-tabs-container">
            <div class="" id="faq-rows">
              <div class="nav flex-column nav-pills" id="vertical-tab-list" role="tablist" aria-orientation="vertical">
                <div class="nav-link nav-pills vertical-tabs-pills mtsmall"
                  [ngClass]="{ active: currentTab === 'tab1' }" (click)="currenttoggleTab('tab1')"
                  id="vertical-first-tab" aria-controls="tab1" aria-expanded="false" class="mb-0 collapsed">
                  <div>
                    <h3 class="ms-3">
                      <div class="d-flex" id="headPotential">
                        <div>
                          <span class="card-header potential-title"> {{ "grammarPage.title-Writers" | translate
                            }}</span>
                        </div>
                      </div>
                    </h3>
                    <div aria-labelledby="tab1" class="collapse" [ngClass]="{ show: currentTab === 'tab1' }" id="tab1"
                      role="tabpanel" data-parent="#vertical-tab-list">
                      <div class="card-body potential-content ms-3 me-3">

                        {{ "grammarPage.detail-Writers" | translate }}
                      </div>
                    </div>
                  </div>

                  <div>
                    <img [src]="getIcon('tab1')" alt="writers and authors" class="float-right mt-3 mr-4 potential-icon"
                      width="16px;" height="8.69px" />
                  </div>
                </div>
                <div class="mb-2"></div>
                <div class="nav-link nav-pills vertical-tabs-pills" [ngClass]="{ active: currentTab === 'tab2' }"
                  (click)="currenttoggleTab('tab2')" id="vertical-second-tab" aria-controls="tab2" aria-expanded="false"
                  class="mb-0 collapsed">
                  <div>
                    <h3 class="ms-3">
                      <div class="d-flex" id="headPotential">
                        <div>
                          <span class="card-header potential-title">{{ "grammarPage.title-Language" | translate
                            }}</span>
                        </div>
                      </div>
                    </h3>
                    <div aria-labelledby="tab2" class="collapse" [ngClass]="{ show: currentTab === 'tab2' }" id="tab2"
                      role="tabpanel" data-parent="#vertical-tab-list">
                      <div class="card-body potential-content ms-3 me-3">

                        {{ "grammarPage.detail-Language" | translate }}
                      </div>
                    </div>
                  </div>

                  <div>
                    <img [src]="getIcon('tab2')" alt="language learners" class="float-right mt-3 mr-4 potential-icon"
                      width="16px;" height="8.69px" />
                  </div>
                </div>
                <div class="mb-2"></div>
                <div class="nav-link nav-pills vertical-tabs-pills" [ngClass]="{ active: currentTab === 'tab3' }"
                  (click)="currenttoggleTab('tab3')" id="vertical-third-tab" aria-controls="tab3" aria-expanded="false"
                  class="mb-0 collapsed">
                  <div>
                    <h3 class="ms-3">
                      <div class="d-flex" id="headPotential">
                        <div>
                          <span class="card-header potential-title"> {{ "grammarPage.title-Students" | translate }}
                          </span>
                        </div>
                      </div>
                    </h3>
                    <div aria-labelledby="tab3" class="collapse" [ngClass]="{ show: currentTab === 'tab3' }" id="tab3"
                      role="tabpanel" data-parent="#vertical-tab-list">
                      <div class="card-body potential-content ms-3 me-3">

                        {{ "grammarPage.detail1-Students" | translate }}
                        <a href="https://www.grammarin.com/handbook" class="aTag"> {{ "grammarPage.grammar-rules" |
                          translate }}</a>

                        {{ "grammarPage.detail2-Students" | translate }}
                      </div>
                    </div>
                  </div>

                  <div>
                    <img [src]="getIcon('tab3')" alt="students & teachers" class="float-right mt-3 mr-4 potential-icon"
                      width="16px;" height="8.69px" />
                  </div>
                </div>
                <div class="mb-2 osmal"></div>

                <div class="nav-link nav-pills vertical-tabs-pills" [ngClass]="{ active: currentTab === 'tab4' }"
                  (click)="currenttoggleTab('tab4')" id="vertical-forth-tab" aria-controls="tab4" aria-expanded="false"
                  class="mb-0 collapsed">
                  <div>
                    <h3 class="ms-3">
                      <div class="d-flex" id="headPotential">
                        <div>
                          <span class="card-header potential-title"> {{ "grammarPage.title-Business" | translate }}
                          </span>
                        </div>
                      </div>
                    </h3>
                    <div aria-labelledby="tab4" class="collapse" [ngClass]="{ show: currentTab === 'tab4' }" id="tab4"
                      role="tabpanel" data-parent="#vertical-tab-list">
                      <div class="card-body potential-content ms-3 me-3">

                        {{ "grammarPage.detail-Business" | translate }}
                      </div>
                    </div>
                  </div>

                  <div>
                    <img [src]="getIcon('tab4')" alt="business professionals"
                      class="float-right mt-3 mr-4 potential-icon" width="16px;" height="8.69px" />
                  </div>
                </div>
                <div class="mb-2 osmal"></div>

                <div class="nav-link nav-pills vertical-tabs-pills" [ngClass]="{ active: currentTab === 'tab5' }"
                  (click)="currenttoggleTab('tab5')" id="vertical-five-tab" aria-controls="tab5" aria-expanded="false"
                  class="mb-0 collapsed">
                  <div>
                    <h3 class="ms-3">
                      <div class="d-flex" id="headPotential">
                        <div>
                          <span class="card-header potential-title">
                            {{ "grammarPage.title-WebsiteOwners" | translate }}
                          </span>
                        </div>
                      </div>
                    </h3>
                    <div aria-labelledby="tab5" class="collapse" [ngClass]="{ show: currentTab === 'tab5' }" id="tab5"
                      role="tabpanel" data-parent="#vertical-tab-list">
                      <div class="card-body potential-content ms-3 me-3">

                        {{ "grammarPage.detail-WebsiteOwners" | translate }}
                      </div>
                    </div>
                  </div>

                  <div>
                    <img [src]="getIcon('tab5')" alt="website owners" class="float-right mt-3 mr-4 potential-icon"
                      width="16px;" height="8.69px" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="fqa mt-5 mb-5">
    <div class="container">
      <div class="row text-center justify-content-center">
        <div class="col-lg-9 col-md-9 mb-4">
          <h2 class="title main-display"> {{ "grammarPage.questions-title" | translate }}</h2>
        </div>
      </div>

      <div class="v-pills-tab-list row">
        <div id="row_faqs">
          <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
            <div class="container container-grid" style="width: min(100% - 40px, 768px)">
              <div class="nav-link nav-pills" [ngClass]="{ active: activeTab === 'q1' }" (click)="toggleTab('q1')"
                id="v-pills-first-tab" aria-controls="q1" aria-expanded="false">
                <h3 class="ms-3">
                  <div class="d-flex nav-linkFAQ">
                    <div>
                      <span class="card-header faqHeading" [class.closed]="activeTab !== 'q1'"> {{ "grammarPage.Q1" |
                        translate }}</span>
                    </div>
                    <div>
                      <app-icons-free-tools name="plusIcon" *ngIf="activeTab !== 'q1'" />
                      <app-icons-free-tools name="minusIcon" *ngIf="activeTab === 'q1'" />
                    </div>
                  </div>
                </h3>
                <div aria-labelledby="q1" class="collapse" [ngClass]="{ show: activeTab === 'q1' }" id="q1"
                  role="tabpanel" data-parent="#v-pills-tab-list">
                  <div class="card-body faqPar ms-3 me-3">

                    {{ "grammarPage.A1" | translate }}
                  </div>
                </div>
              </div>

              <div class="nav-link nav-pills" [ngClass]="{ active: activeTab === 'q2' }" (click)="toggleTab('q2')"
                id="v-pills-2nd-tab" aria-controls="q2" aria-expanded="false">
                <h3 class="ms-3">
                  <div class="d-flex nav-linkFAQ">
                    <div>
                      <span class="card-header faqHeading" [class.closed]="activeTab !== 'q2'"> {{ "grammarPage.Q2" |
                        translate }}</span>
                    </div>
                    <div>
                      <app-icons-free-tools name="plusIcon" *ngIf="activeTab !== 'q2'" />
                      <app-icons-free-tools name="minusIcon" *ngIf="activeTab === 'q2'" />
                    </div>
                  </div>
                </h3>
                <div aria-labelledby="q2" class="collapse" [ngClass]="{ show: activeTab === 'q2' }" id="q2"
                  role="tabpanel" data-parent="#v-pills-tab-list">
                  <div class="card-body faqPar ms-3 me-3">

                    {{ "grammarPage.A2" | translate }}
                  </div>
                </div>
              </div>

              <div class="nav-link nav-pills" [ngClass]="{ active: activeTab === 'q3' }" (click)="toggleTab('q3')"
                id="v-pills-3rd-tab" aria-controls="q3" aria-expanded="false">
                <h3 class="ms-3">
                  <div class="d-flex nav-linkFAQ">
                    <div>
                      <span class="card-header faqHeading" [class.closed]="activeTab !== 'q3'"> {{ "grammarPage.Q3" |
                        translate }}</span>
                    </div>
                    <div>
                      <app-icons-free-tools name="plusIcon" *ngIf="activeTab !== 'q3'" />
                      <app-icons-free-tools name="minusIcon" *ngIf="activeTab === 'q3'" />
                    </div>
                  </div>
                </h3>
                <div aria-labelledby="q3" class="collapse" [ngClass]="{ show: activeTab === 'q3' }" id="q3"
                  role="tabpanel" data-parent="#v-pills-tab-list">
                  <div class="card-body faqPar ms-3 me-3">

                    {{ "grammarPage.A3" | translate }}
                  </div>
                </div>
              </div>

              <div class="nav-link nav-pills" [ngClass]="{ active: activeTab === 'q4' }" (click)="toggleTab('q4')"
                id="v-pills-4th-tab" aria-controls="q4" aria-expanded="false">
                <h3 class="ms-3">
                  <div class="d-flex nav-linkFAQ">
                    <div>
                      <span class="card-header faqHeading" [class.closed]="activeTab !== 'q4'">{{ "grammarPage.Q4" |
                        translate }}</span>
                    </div>
                    <div>
                      <app-icons-free-tools name="plusIcon" *ngIf="activeTab !== 'q4'" />
                      <app-icons-free-tools name="minusIcon" *ngIf="activeTab === 'q4'" />
                    </div>
                  </div>
                </h3>
                <div aria-labelledby="q4" class="collapse" [ngClass]="{ show: activeTab === 'q4' }" id="q4"
                  role="tabpanel" data-parent="#v-pills-tab-list">
                  <div class="card-body faqPar ms-3 me-3">

                    {{ "grammarPage.A4" | translate }}
                  </div>
                </div>
              </div>

              <div class="nav-link nav-pills" [ngClass]="{ active: activeTab === 'q5' }" (click)="toggleTab('q5')"
                id="v-pills-5th-tab" aria-controls="q5" aria-expanded="false">
                <h3 class="ms-3">
                  <div class="d-flex nav-linkFAQ">
                    <div>
                      <span class="card-header faqHeading" [class.closed]="activeTab !== 'q5'"> {{ "grammarPage.Q5" |
                        translate }}</span>
                    </div>
                    <div>
                      <app-icons-free-tools name="plusIcon" *ngIf="activeTab !== 'q5'" />
                      <app-icons-free-tools name="minusIcon" *ngIf="activeTab === 'q5'" />
                    </div>
                  </div>
                </h3>
                <div aria-labelledby="q5" class="collapse" [ngClass]="{ show: activeTab === 'q5' }" id="q5"
                  role="tabpanel" data-parent="#v-pills-tab-list">
                  <div class="card-body faqPar ms-3 me-3">

                    {{ "grammarPage.A5" | translate }}
                  </div>
                </div>
              </div>

              <div class="nav-link nav-pills" [ngClass]="{ active: activeTab === 'q6' }" (click)="toggleTab('q6')"
                id="v-pills-6th-tab" aria-controls="q6" aria-expanded="false">
                <h3 class="ms-3">
                  <div class="d-flex nav-linkFAQ">
                    <div>
                      <span class="card-header faqHeading" [class.closed]="activeTab !== 'q6'"> {{ "grammarPage.Q6" |
                        translate }}</span>
                    </div>
                    <div>
                      <app-icons-free-tools name="plusIcon" *ngIf="activeTab !== 'q6'" />
                      <app-icons-free-tools name="minusIcon" *ngIf="activeTab === 'q6'" />
                    </div>
                  </div>
                </h3>
                <div aria-labelledby="q6" class="collapse" [ngClass]="{ show: activeTab === 'q6' }" id="q6"
                  role="tabpanel" data-parent="#v-pills-tab-list">
                  <div class="card-body faqPar ms-3 me-3">

                    {{ "grammarPage.A6" | translate }}
                  </div>
                </div>
              </div>

              <div class="nav-link nav-pills" [ngClass]="{ active: activeTab === 'q7' }" (click)="toggleTab('q7')"
                id="v-pills-7th-tab" aria-controls="q7" aria-expanded="false">
                <h3 class="ms-3">
                  <div class="d-flex nav-linkFAQ">
                    <div>
                      <span class="card-header faqHeading" [class.closed]="activeTab !== 'q7'"> {{ "grammarPage.Q7" |
                        translate }}</span>
                    </div>
                    <div>
                      <app-icons-free-tools name="plusIcon" *ngIf="activeTab !== 'q7'" />
                      <app-icons-free-tools name="minusIcon" *ngIf="activeTab === 'q7'" />
                    </div>
                  </div>
                </h3>
                <div aria-labelledby="q7" class="collapse" [ngClass]="{ show: activeTab === 'q7' }" id="q7"
                  role="tabpanel" data-parent="#v-pills-tab-list">
                  <div class="card-body faqPar ms-3 me-3">
                    Besides an AI grammar checker, GrammarIn also offers a free
                    {{ "grammarPage.A7" | translate }}
                    <a href="https://www.grammarin.com/plagiarism-checker" [routerLink]="['/plagiarism-checker']"
                      class="aTag">
                      {{ "grammarPage.A7a" | translate }}</a> {{ "grammarPage.A72" | translate }}
                  </div>
                </div>
              </div>

              <div class="nav-link nav-pills" [ngClass]="{ active: activeTab === 'q8' }" (click)="toggleTab('q8')"
                id="v-pills-7th-tab" aria-controls="q8" aria-expanded="false">
                <h3 class="ms-3">
                  <div class="d-flex nav-linkFAQ">
                    <div>
                      <span class="card-header faqHeading" [class.closed]="activeTab !== 'q8'"> {{ "grammarPage.Q8" |
                        translate }}</span>
                    </div>
                    <div>
                      <app-icons-free-tools name="plusIcon" *ngIf="activeTab !== 'q8'" />
                      <app-icons-free-tools name="minusIcon" *ngIf="activeTab === 'q8'" />
                    </div>
                  </div>
                </h3>
                <div aria-labelledby="q7" class="collapse" [ngClass]="{ show: activeTab === 'q8' }" id="q7"
                  role="tabpanel" data-parent="#v-pills-tab-list">
                  <div class="card-body faqPar ms-3 me-3">
                    {{ "grammarPage.A8" | translate }}
                  </div>
                </div>
              </div>
              <div class="nav-link nav-pills" [ngClass]="{ active: activeTab === 'q9' }" (click)="toggleTab('q9')"
                id="v-pills-7th-tab" aria-controls="q9" aria-expanded="false">
                <h3 class="ms-3">
                  <div class="d-flex nav-linkFAQ">
                    <div>
                      <span class="card-header faqHeading" [class.closed]="activeTab !== 'q9'">{{ "grammarPage.Q9" |
                        translate }}</span>
                    </div>
                    <div>
                      <app-icons-free-tools name="plusIcon" *ngIf="activeTab !== 'q9'" />
                      <app-icons-free-tools name="minusIcon" *ngIf="activeTab === 'q9'" />
                    </div>
                  </div>
                </h3>
                <div aria-labelledby="q9" class="collapse" [ngClass]="{ show: activeTab === 'q9' }" id="q7"
                  role="tabpanel" data-parent="#v-pills-tab-list">
                  <div class="card-body faqPar ms-3 me-3">

                    {{ "grammarPage.A9" | translate }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!--  -->
  <app-feedback></app-feedback>
  <div *ngIf="error" class="backdrop" id="error-22"></div>
  <div *ngIf="error" class="content-div" id="error-22-cont">
    <div class="text-center" id="error-22-contInner">
      <app-icons-free-tools name="errorIcon" />
      <div class="content-div-p">
        <p class="error mt-4" id="errorPT">
          {{ errorAlerts }}
        </p>
      </div>
      <button class="mt-5 butn-alert" (click)="closeErrorDiv()">Ok</button>
    </div>
  </div>

  <app-footer></app-footer>
</main>